import React from 'react';
import { ArrowLeft, FileText } from 'lucide-react';
import { useNavigate, Link } from 'react-router-dom';
import { appPath } from '../utils/appRouting';

const LegalNotesAI = () => {
  const navigate = useNavigate();

  return (
    <div className="h-[100dvh] overflow-y-auto bg-gradient-to-b from-muted/30 to-background text-foreground scroll-smooth">
      {/* Header */}
      <header className="bg-background/80 backdrop-blur-md border-b border-border sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate(appPath('/'))}
              className="flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              <span className="text-sm">Torna alla Home</span>
            </button>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-gradient-to-br from-blue-600 to-blue-800 rounded-lg flex items-center justify-center">
                <span className="text-yellow-400 font-bold text-sm">S+</span>
              </div>
              <span className="text-sm font-semibold text-foreground hidden sm:block">SOSTEGNO PRO+</span>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-8 md:py-12">
        {/* Title Section */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary/10 rounded-2xl mb-4">
            <FileText className="w-8 h-8 text-primary" />
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-foreground mb-3">
            Note legali – Uso dell’Intelligenza Artificiale
          </h1>
          <p className="text-muted-foreground">Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>
        </div>

        {/* Content */}
        <div className="bg-card rounded-2xl shadow-sm border border-border overflow-hidden">
          <div className="p-6 md:p-8 space-y-6">
            <section>
              <h2 className="text-xl font-semibold text-foreground mb-3 flex items-center gap-2">
                <span className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center text-primary text-sm font-bold">
                  1
                </span>
                Dichiarazione
              </h2>
              <p className="text-muted-foreground leading-relaxed">
                I contenuti generati da SostegnoPro tramite intelligenza artificiale costituiscono esclusivamente bozze di supporto alla redazione dei documenti scolastici e non rappresentano documenti ufficiali né atti amministrativi. La verifica, l’adattamento, la validazione e la firma dei documenti restano di esclusiva responsabilità dell’utente.
              </p>
            </section>
          </div>
        </div>

        {/* Footer Links */}
        <div className="mt-8 flex flex-wrap justify-center gap-6 text-sm text-muted-foreground">
          <Link to={appPath('/privacy')} className="hover:text-foreground transition-colors">Privacy Policy</Link>
          <Link to={appPath('/terms')} className="hover:text-foreground transition-colors">Termini e Condizioni</Link>
          <Link to={appPath('/cookie-policy')} className="hover:text-foreground transition-colors">Cookie Policy</Link>
          <Link to={appPath('/')} className="hover:text-foreground transition-colors">Home</Link>
        </div>
      </main>
    </div>
  );
};

export default LegalNotesAI;
